module.exports = __webpack_public_path__ + "img/slider_2.1f1b9e4f.jpg";